import { useMutation } from "@tanstack/solid-query";
import { axiosInstance } from "@/api/client";
import type {
  SendSupportRequestRequest,
  SendSupportRequestResponse,
} from "./types";

// 1. Base mutator function
export const sendSupportRequest = async (input: SendSupportRequestRequest) => {
  const { data } = await axiosInstance.post<SendSupportRequestResponse>(
    "/support/send-request",
    input,
  );
  return data;
};

// 2. Custom hook
export const useSendSupportRequest = () => {
  return useMutation(() => ({
    mutationFn: (input: SendSupportRequestRequest) => sendSupportRequest(input),
  }));
};

export const sendFreelancerToolkitRequest = async (
  input: SendSupportRequestRequest,
) => {
  const { data } = await axiosInstance.post<SendSupportRequestResponse>(
    "/support/send-freelance-toolkit-request",
    input,
  );
  return data;
};

export const useSendFreelancerToolkitRequest = () => {
  return useMutation(() => ({
    mutationFn: (input: SendSupportRequestRequest) =>
      sendFreelancerToolkitRequest(input),
  }));
};
